(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nw-compatibility"] && !Shopify.designMode) return;
  try {
    /*
   * Same flow as odemobile's snippets/product-compatibility.liquid, without
   * jQuery:
   *   - brands from the brand index, models from the chosen brand's page,
   *     grouped as "TOP BRAND" / "DEVICE BRAND" and "Top Devices" /
   *     "Other Devices" (first #model-images grid vs the rest)
   *   - a model's /pages/<device>-accessories link is checked against its
   *     collection, /collections/<device>/, which is where the device's
   *     #device-interfaces is published
   *   - case-sensitive "contains" of the product interface in that list
   *   - no message when the device publishes no interface list
   */
  class NwCompatibility extends HTMLElement {
    async connectedCallback() {
      this.brand = this.querySelector('[data-nw-compat-brand]');
      this.model = this.querySelector('[data-nw-compat-model]');
      this.result = this.querySelector('[data-nw-compat-result]');
      this.modelsRequest = 0;

      // Device known from the collection this page was reached through: show
      // it straight away as placeholder options, before anything is fetched.
      const known = Boolean(this.dataset.knownModelUrl);
      if (known) this.showKnown();

      this.lib = await import(
        document.querySelector('script[src*="nw-device-data"]')?.src || '/assets/nw-device-data.js'
      );

      this.brand.addEventListener('change', () => this.onBrand());
      this.model.addEventListener('change', () => {
        this.touched = true;
        this.check();
      });
      // Brands load on first interaction, not on page load: this is a support
      // widget, and a product page should not pay two fetches for it up front.
      this.brand.addEventListener('focus', () => this.loadBrands(), { once: true });
      this.brand.addEventListener('pointerdown', () => this.loadBrands(), { once: true });

      // Known device: in parallel, check it against this product and swap the
      // placeholder options for the real brand/model lists.
      if (known) {
        this.checkKnown();
        this.preselectKnown();
      }
    }

    // One shared promise, so the pre-selection and a focus/pointerdown can't
    // each append the brand list.
    loadBrands() {
      this.brandsLoading ??= this.lib
        .getEntries(this.dataset.brandIndex)
        .then((brands) => {
          this.lib.appendGroupedOptions(this.brand, this.regroup(brands, 'TOP BRAND', 'DEVICE BRAND'));
        })
        .catch(() => {
          // Placeholder stays; odemobile shows nothing here either.
        });
      return this.brandsLoading;
    }

    async onBrand() {
      this.touched = true;
      this.result.hidden = true;
      await this.loadModels();
    }

    // keepCurrent leaves the select as it is until the new list arrives, so a
    // pre-selected model doesn't blank out while its brand's page loads.
    // Only the latest request fills the select - a brand changed mid-fetch
    // wins over the one before it.
    async loadModels(keepCurrent = false) {
      const request = ++this.modelsRequest;
      const reset = () => {
        this.model.replaceChildren(new Option('2. Choose a model', ''));
        this.model.disabled = true;
      };
      if (!keepCurrent) reset();
      if (!this.brand.value) return;

      try {
        const models = await this.lib.getEntries(this.brand.value);
        if (request !== this.modelsRequest) return;
        reset();
        this.lib.appendGroupedOptions(this.model, this.regroup(models, 'Top Devices', 'Other Devices'));
        this.model.disabled = models.length === 0;
      } catch {
        // Stays as it was.
      }
    }

    showKnown() {
      const { knownModelUrl, knownBrandLabel, knownModelLabel } = this.dataset;

      this.tempBrand = new Option(knownBrandLabel, knownModelUrl);
      this.brand.append(this.tempBrand);
      this.brand.value = knownModelUrl;

      this.tempModel = new Option(knownModelLabel, knownModelUrl);
      this.model.append(this.tempModel);
      this.model.disabled = false;
      this.model.value = knownModelUrl;
    }

    // Runs alongside preselectKnown. Liquid already rendered "compatible"
    // when it had both names; this replaces it with the real verdict. Nothing
    // changes when the product has no interface, the device publishes none,
    // the fetch fails, or the shopper has already picked something else.
    async checkKnown() {
      const { knownModelUrl, knownBrandLabel, knownModelLabel } = this.dataset;
      // No interface on the product would always read "not compatible",
      // which contradicts it being listed in this device's collection.
      if (!this.dataset.interface) return;
      try {
        const verdict = await this.lib.isCompatible(knownModelUrl, this.dataset.interface);
        if (verdict === null || this.touched) return;
        this.say(verdict ? 'yes' : 'no', `${knownBrandLabel} ${knownModelLabel}`.trim(), knownModelUrl);
      } catch {
        // Liquid's message, if any, stays.
      }
    }

    // Swaps the placeholder options for the full lists in the background.
    // Brand matched by name against the brand index, model by its
    // /pages/<device>-accessories link against the collection's handle (or
    // by name). Whatever can't be matched keeps its placeholder option,
    // moved after the full list so every other entry stays visible.
    async preselectKnown() {
      const { knownModelUrl, knownBrandLabel, knownModelLabel } = this.dataset;

      await this.loadBrands();
      if (this.touched) return;

      const brandOption = this.findOption(
        this.brand,
        (option) => option !== this.tempBrand && this.sameName(option.text, knownBrandLabel)
      );
      if (!brandOption) {
        this.brand.append(this.tempBrand);
        this.brand.value = knownModelUrl;
        return;
      }
      this.tempBrand.remove();
      this.brand.value = brandOption.value;

      await this.loadModels(true);
      if (this.touched) return;

      const knownHandle = this.handle(knownModelUrl);
      const modelOption = this.findOption(
        this.model,
        (option) =>
          this.handle(option.value) === knownHandle ||
          this.sameName(option.text, knownModelLabel) ||
          this.sameName(option.text, `${knownBrandLabel} ${knownModelLabel}`)
      );
      if (!modelOption) {
        this.model.append(this.tempModel);
        this.model.disabled = false;
      }
      this.model.value = modelOption ? modelOption.value : knownModelUrl;
    }

    findOption(select, test) {
      return [...select.options].find((option) => option.value && test(option));
    }

    sameName(a, b) {
      const normalize = (value) => (value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      return Boolean(normalize(a)) && normalize(a) === normalize(b);
    }

    // "/collections/apple-iphone-15" and "/pages/apple-iphone-15-accessories"
    // both give "apple-iphone-15".
    handle(url) {
      if (!url) return '';
      const path = new URL(url, location.origin).pathname.replace(/\/+$/, '');
      return path
        .split('/')
        .pop()
        .replace(/-accessories$/, '')
        .toLowerCase();
    }

    // Entries from the page's first #model-images grid go under `top`,
    // everything after it under `other`.
    regroup(entries, top, other) {
      const firstGroup = entries[0]?.group;
      return entries.map((entry) => ({ ...entry, group: entry.group === firstGroup ? top : other }));
    }

    async check() {
      this.result.hidden = true;
      if (!this.model.value) return;

      const deviceUrl = this.model.value.replace('/pages/', '/collections/').replace('-accessories', '/');
      const name = this.brand.selectedOptions[0].textContent + ' ' + this.model.selectedOptions[0].textContent;

      this.brand.disabled = true;
      this.model.disabled = true;
      try {
        const verdict = await this.lib.isCompatible(deviceUrl, this.dataset.interface);
        // null: the device publishes no interface list - nothing is shown.
        if (verdict !== null) this.say(verdict ? 'yes' : 'no', name.trim(), deviceUrl);
      } catch {
        // Fetch failed - nothing is shown.
      } finally {
        this.brand.disabled = false;
        this.model.disabled = false;
      }
    }

    // [model] in the message becomes a link to the device's collection.
    say(state, name, url) {
      const [before, after = ''] = (this.dataset[state] || '').split('[model]');
      const link = document.createElement('a');
      link.href = url;
      link.textContent = name;

      this.result.dataset.state = state;
      this.result.replaceChildren(before, link, after);
      this.result.hidden = false;
    }
  }

  if (!customElements.get('nw-compatibility')) {
    customElements.define('nw-compatibility', NwCompatibility);
  }
  } catch(e) { console.error(e); }
})();

})();
